import React from 'react';
import Chip from "@mui/material/Chip";


export default function ArgoChipHook(props) {

    const fileName = props.fileName ?? "file-name";
    const fieldName = props.fieldName ?? "field-name";
    const index = props.index ?? ""; // If field is built in a loop index is required to know which field to match up with

    const uniqueIdentifier = fileName + "-chip-" + fieldName + index;

    const variant = props.variant ?? "filled"; //NOTE: use "outlined" for chip with white fill
    const label = props.label ?? "";
    //const useTrackableAvatar = props.useTrackableAvatar ?? false; // Tags used to be able to be marked as trackable, functionality deprecated
    const title = props.title ?? "";

    const onDelete = props.onDelete ?? undefined;

    const handleOnDelete = (event) => {
        onDelete(event, label, index);
    };

    return (
        <div title={title} style={{paddingRight: "10px"}}>
            <Chip key={uniqueIdentifier}
                  id={uniqueIdentifier}
                  name={uniqueIdentifier}
                  variant={variant}
                  label={label}
                  onDelete={typeof onDelete === "function" ? handleOnDelete : undefined}
                  //avatar={useTrackableAvatar ? <FlashOnIcon/> : ""}
            />
        </div>
    );
}



